// extracted by mini-css-extract-plugin
export default {"pills":"MediaGroupPills-module-pills"};